module.exports = __webpack_public_path__ + "img/icon-globe.ff6c55f1.svg";